// https://vuex.vuejs.org/en/mutations.html

export default {
    refreshRoles (state, roles) {
      state.list = roles
    },
  }
